import { render, staticRenderFns } from "./AlertAddPage.vue?vue&type=template&id=c361e0ee&scoped=true&"
import script from "./AlertAddPage.vue?vue&type=script&lang=ts&"
export * from "./AlertAddPage.vue?vue&type=script&lang=ts&"
import style0 from "./AlertAddPage.vue?vue&type=style&index=0&id=c361e0ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c361e0ee",
  null
  
)

export default component.exports